import React from 'react'
import { numberFormat } from '../../../helpers/numberFormat'
import { numberToDateString } from '../../../helpers/numberToDateString'
import Table from 'react-bootstrap/Table';


const EnrolledProgramDetailProgramComp = (props) => {
    return (
        <>
            <div className='table-responsive'>
                <table className='table mb-3'>
                    <thead>
                        <tr>
                            <th className='white-bg'>Nama Program</th>
                            <th className='white-bg'>Jadwal Program</th>
                            <th className='white-bg'>Harga</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            props.transactionItems.map((row, index) => (
                                <tr key={index}>
                                    <td>{row.Schedule.Program.name}</td>
                                    <td>{numberToDateString(row.Schedule.startDate)} s/d {numberToDateString(row.Schedule.endDate)}</td>
                                    <td style={{ color: '#0C86D9', fontSize: '16px' }}>{numberFormat(row.price)}</td>
                                </tr>
                            ))
                        }
                    </tbody>
                </table>
            </div>
            {
                props.transactionItems.map((row, index) => (
                    <>
                        <div key={index} className='row mt-3'>
                            <h3 className='mb-3'>Daftar Peserta</h3>
                            <div className="card" style={{
                                backgroundColor: '#F2F2F2',
                            }}>
                                <div className="card-body">
                                    <div className='table-responsive'>
                                        <table className='table mb-3'>
                                            <thead>
                                                <tr>
                                                    <th>Nama</th>
                                                    <th>Email</th>
                                                    <th>No Telepon</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    row.Participants.map((p, idx) => (
                                                        <tr key={idx}>
                                                            <td>{p.firstName}&nbsp;{p.lastName}</td>
                                                            <td>{p.email}</td>
                                                            <td>{p.mobilePhone}</td>
                                                        </tr>
                                                    ))
                                                }
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </>
                ))
            }
        </>
    )
}

export default EnrolledProgramDetailProgramComp
